import { cssVar } from '@mfw/common';
import { alpha } from '@mui/material/styles';

import { secondary, success, warning, common, error, info } from './palette';

// ----------------------------------------------------------------------

interface CustomShadows {
  secondary: string;
  dropdown: string;
  //
  accent: string;
  primary: string;
  success: string;
  warning: string;
  dialog: string;
  error: string;
  info: string;
  //
  card: string;
  z12: string;
  z16: string;
  z20: string;
  z24: string;
  z1: string;
  z4: string;
  z8: string;
}

declare module '@mui/material/styles' {
  interface Theme {
    customShadows: CustomShadows;
  }
  interface ThemeOptions {
    customShadows?: CustomShadows;
  }
}

// ----------------------------------------------------------------------

export function customShadows() {
  const color = common.black;

  const transparent = alpha(color, 0.16);

  return {
    //
    card: `0 0 2px 0 ${alpha(color, 0.2)}, 0 12px 24px -4px ${alpha(color, 0.12)}`,
    dialog: `-40px 40px 80px -8px ${alpha(common.black, 0.24)}`,
    dropdown: `0 0 2px 0 ${alpha(color, 0.24)}, -20px 20px 40px -4px ${alpha(color, 0.24)}`,
    error: `0 8px 16px 0 ${alpha(error.main, 0.24)}`,
    info: `0 8px 16px 0 ${alpha(info.main, 0.24)}`,
    //
    // `alpha(primary.main, …)` resolved against the STATIC palette module, so
    // every brand shadow kept painting the build-time green for rebranded
    // tenants. CSS vars re-resolve on every paint; `rgba(var(--…-mainChannel)
    // / a)` is the form that works, because alpha() cannot parse a var().
    accent: `0 8px 16px 0 rgba(${cssVar.accent.mainChannel} / 0.24)`,
    primary: `0 8px 16px 0 rgba(${cssVar.primary.mainChannel} / 0.24)`,
    secondary: `0 8px 16px 0 ${alpha(secondary.main, 0.24)}`,
    success: `0 8px 16px 0 ${alpha(success.main, 0.24)}`,
    warning: `0 8px 16px 0 ${alpha(warning.main, 0.24)}`,
    z1: `0 1px 2px 0 ${transparent}`,
    z4: `0 4px 8px 0 ${transparent}`,
    z8: `0 8px 16px 0 ${transparent}`,
    z12: `0 12px 24px -4px ${transparent}`,
    z16: `0 16px 32px -4px ${transparent}`,
    z20: `0 20px 40px -4px ${transparent}`,
    z24: `0 24px 48px 0 ${transparent}`,
  };
}
